import { Transition } from 'react-transition-group';

import {
  StyledToastContainer,
  StyledToast,
  StyledToastBody,
  StyledCloseButton,
  getTextColor,
} from './styles';

const defaultStyle = {
  transition: `transform 200ms, opacity 200ms ease`,
  opacity: 0,
};
const transitionStyles = {
  entering: { transform: 'scale(0.5)', opacity: 0 },
  entered: { transform: 'scale(1.0)', opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

const Toast = ({
  children,
  show = false,
  variant = 'success',
  onClose,
  className,
  yOffset = null,
  ...others
}) => {
  return (
    <Transition
      in={show}
      timeout={{
        appear: 100,
        enter: 300,
        exit: 300,
      }}
      appear
      unmountOnExit
    >
      {(state) => (
        <StyledToastContainer
          className={className}
          aria-live="polite"
          aria-atomic="true"
          zIndex={others.zIndex}
        >
          <StyledToast
            variant={variant}
            onClose={onClose}
            yOffset={yOffset}
            {...others}
            style={{ ...defaultStyle, ...transitionStyles[state] }}
          >
            <StyledToastBody
              data-qa-element="toast"
              data-qa-variant={variant}
              variant={variant}
              fullWidth={others.fullWidth}
            >
              {children}
              <StyledCloseButton
                color={getTextColor({ variant })}
                onClick={onClose}
              />
            </StyledToastBody>
          </StyledToast>
        </StyledToastContainer>
      )}
    </Transition>
  );
};

export { Toast };
